import React from 'react'
import { COLORS } from 'helpers/globals'

class Overlay extends google.maps.OverlayView {
  constructor({ map }) {
    super()
    this.visible = false
    this.position = null
    this.bubble = null
    this.containerDiv = null
    this.timer = null
    this.setMap(map)
  }

  onAdd() {
    const bubble = document.createElement('div')
    bubble.textContent = 'Turn removed'
    bubble.style.position = 'absolute'
    bubble.style.top = 0
    bubble.style.left = 0
    bubble.style.transform = 'translate(-50%, calc(-100% - 18px))'
    bubble.style.background = COLORS.primary
    bubble.style.color = 'white'
    bubble.style.padding = '0.5rem'
    bubble.style.borderRadius = '0.5rem'
    bubble.style.boxShadow = '0px 2px 10px 1px rgba(0, 0, 0, 0.5)'
    this.bubble = bubble

    const bubbleArrow = document.createElement('div')
    bubbleArrow.style.position = 'absolute'
    bubbleArrow.style.top = 0
    bubbleArrow.style.left = 0
    bubbleArrow.style.transform = 'translate(-50%, -18px)'
    bubbleArrow.style.width = 0
    bubbleArrow.style.height = 0
    bubbleArrow.style.borderRight = '6px solid transparent'
    bubbleArrow.style.borderLeft = '6px solid transparent'
    bubbleArrow.style.borderTop = `8px solid ${COLORS.primary}`

    const containerDiv = document.createElement('div')
    containerDiv.appendChild(bubble)
    containerDiv.appendChild(bubbleArrow)
    containerDiv.style.position = 'absolute'
    containerDiv.style.width = '100%'

    this.containerDiv = containerDiv
    this.setVisibility(this.visible)

    google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.containerDiv)

    this.getPanes().floatPane.appendChild(this.containerDiv)
  }

  setVisibility(visible) {
    if (visible) {
      this.containerDiv.style.visibility = 'visible'
      this.containerDiv.style.setProperty('opacity', 1, 'important')
      this.containerDiv.style.transition = 'visibility 0s linear 0s, opacity 200ms'
    } else {
      this.containerDiv.style.visibility = 'hidden'
      this.containerDiv.style.setProperty('opacity', 0, 'important')
      this.containerDiv.style.transition = 'visibility 0s linear 200ms, opacity 200ms'
    }
  }

  hide = _ => {
    clearTimeout(this.timer)
    this.visible = false
    this.setVisibility(false)
  }

  showRemovalText(position) {
    clearTimeout(this.timer)
    this.position = position
    this.visible = true
    this.bubble.textContent = 'Turn removed'
    this.timer = setTimeout(this.hide, 1500)

    this.draw()
  }

  showInfoText(position) {
    clearTimeout(this.timer)
    this.position = position
    this.visible = true
    this.bubble.textContent = 'Click and drag to add turns, delete turns with right click'
    this.timer = setTimeout(this.hide, 3000)

    this.draw()
  }

  draw() {
    const { containerDiv, position } = this

    if (!this.visible) return

    const divPosition = this.getProjection().fromLatLngToDivPixel(this.position)
    const display = Math.abs(divPosition.x) < 5000 && Math.abs(divPosition.y) < 5000

    if (display) {
      containerDiv.style.left = divPosition.x + 'px'
      containerDiv.style.top = divPosition.y + 'px'
    }

    this.setVisibility(display)
  }

  onRemove() {
    if (this.containerDiv.parentElement) {
      this.containerDiv.parentElement.removeChild(this.containerDiv)
    }
    clearTimeout(this.timer)
    this.containerDiv = null
  }
}

export default class extends React.Component {
  constructor(props) {
    super(props)
    this.overlay = null
  }

  componentDidMount = _ => {
    const { map, addReference } = this.props

    this.overlay = new Overlay({ map })
    addReference(this.overlay)
  }

  componentWillUnmount = _ => this.overlay && this.overlay.setMap(null)

  shouldComponentUpdate() {
    return false
  }

  render() {
    return null
  }
}



// WEBPACK FOOTER //
// ./src/components/Wire/TooltipOverlay.js